module.exports = __webpack_public_path__ + "static/img/parents-test.f0131fc5.png";